var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import API from './API';
import ClientOAuth2 from 'client-oauth2';
import { GetActiveCountryCookie } from './Helper';
import { Buffer } from 'buffer/';
const DEBUG_MODE_VALIDATE = process.env.VUE_APP_DEBUG_MODE_VALIDATE && process.env.VUE_APP_ENV !== 'production';
var refreshTokenPromise = undefined;
//Get domain from window location to callback to for OAUTH
const domainForCallback = (window ? window.location.origin : '');
/**
 * @class APIHelper
 * Handles OAuth request with the server
 */
class APIHelper {
    constructor() {
        var _a, _b;
        this.AuthAPIs = [];
        this.NonAuthAPIs = [];
        this.OAUTH_SERVER_CONF = {
            OAUTH_SERVER_URL: process.env.VUE_APP_OAUTH_SERVER_URL,
            CLIENT_ID: process.env.VUE_APP_CLIENT_ID,
            CLIENT_SECRET: process.env.VUE_APP_CLIENT_SECRET,
            CALLBACK_URL: `${domainForCallback}/passback`,
        };
        this.oauthObj = new ClientOAuth2({
            clientId: this.OAUTH_SERVER_CONF.CLIENT_ID,
            clientSecret: this.OAUTH_SERVER_CONF.CLIENT_SECRET,
            accessTokenUri: this.OAUTH_SERVER_CONF.OAUTH_SERVER_URL + '/oauth/token',
            authorizationUri: this.OAUTH_SERVER_CONF.OAUTH_SERVER_URL + '/oauth/authorize',
            redirectUri: this.OAUTH_SERVER_CONF.CALLBACK_URL,
            scopes: undefined, //['DDD_Report'],
        });
        this.AuthAPI = new API(process.env.VUE_APP_OAUTH_SERVER_URL);
        this.AdminAPI = new API(process.env.VUE_APP_API_URL_ADMIN);
        this.ArchistarAPI = new API(process.env.VUE_APP_API_URL_ARCHISTAR);
        this.GeneratorAPI = new API(process.env.VUE_APP_API_URL_GENERATOR);
        this.HomesMgmtAPI = new API(process.env.VUE_APP_API_URL_HOMESMGMT);
        this.PlanningCodesAPI = new API(process.env.VUE_APP_API_URL_PLANNING_CODES);
        this.AcademyAPI = new API(process.env.VUE_APP_API_URL_ACADEMY);
        this.WorkspaceAPI = new API(process.env.VUE_APP_API_URL_WORKSPACE);
        this.CommunityAPI = new API(process.env.VUE_APP_API_URL_COMMUNITY);
        this.DocumentAPI = new API(process.env.VUE_APP_API_URL_DOCUMENT);
        this.ManageAPI = new API(process.env.VUE_APP_API_URL_MANAGE);
        this.DnaAPI = new API(process.env.VUE_APP_API_URL_DNA);
        this.GnafSearchAPI = new API(process.env.VUE_APP_API_URL_GNAF_SEARCH);
        this.SiteCardAPI = new API(process.env.VUE_APP_API_URL_SITE_CARD);
        this.ComplianceAPI = new API(process.env.VUE_APP_API_URL_COMPLIANCE);
        this.EcheckAPI = new API(process.env.VUE_APP_API_URL_ECHECK);
        this.ExternalAPI = new API(null);
        this.AuthAPIs.push(this.AuthAPI);
        this.AuthAPIs.push(this.AdminAPI);
        this.AuthAPIs.push(this.ArchistarAPI);
        this.AuthAPIs.push(this.GeneratorAPI);
        this.AuthAPIs.push(this.HomesMgmtAPI);
        this.AuthAPIs.push(this.PlanningCodesAPI);
        this.AuthAPIs.push(this.AcademyAPI);
        this.AuthAPIs.push(this.WorkspaceAPI);
        this.AuthAPIs.push(this.CommunityAPI);
        this.AuthAPIs.push(this.DocumentAPI);
        this.AuthAPIs.push(this.ManageAPI);
        this.AuthAPIs.push(this.DnaAPI);
        this.AuthAPIs.push(this.GnafSearchAPI);
        this.AuthAPIs.push(this.SiteCardAPI);
        this.AuthAPIs.push(this.ComplianceAPI);
        this.AuthAPIs.push(this.EcheckAPI);
        this.NonAuthAPIs.push(this.ExternalAPI);
        const countryCode = GetActiveCountryCookie();
        this.AuthAPIs.forEach((itApi) => {
            itApi.setHeaderCommons('X-as-country-code', countryCode !== null && countryCode !== void 0 ? countryCode : 'au');
        });
        if (this.isUserLoggedIn()) {
            this.AuthAPIs.forEach((itApi) => {
                itApi.setHeaderCommons('Authorization', 'Bearer ' + localStorage.getItem("tka"));
            });
            this.token = this.oauthObj.createToken((_a = localStorage.getItem("tka")) !== null && _a !== void 0 ? _a : "", (_b = localStorage.getItem("tkr")) !== null && _b !== void 0 ? _b : "", 'bearer', {});
        }
        this.jwt_override = null;
        this.activeCityMode = null;
    }
    isUserLoggedIn() {
        if (this.hasJwtOverride())
            return true;
        return (localStorage.getItem("tka") !== null && localStorage.getItem("tkr") !== null);
    }
    validateToken() {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            if (DEBUG_MODE_VALIDATE)
                console.log('validateToken - start', 'access', localStorage.getItem("tka"), 'refresh', localStorage.getItem("tkr"));
            if (!(localStorage.getItem("tka") !== null && localStorage.getItem("tkr") !== null)) {
                if (DEBUG_MODE_VALIDATE)
                    console.log('validateToken - no token, rejecting');
                return yield this.refreshToken();
            }
            else {
                try {
                    const valResp = yield ((_a = this.AuthAPI) === null || _a === void 0 ? void 0 : _a.get('/auth/validatetoken'));
                    if (DEBUG_MODE_VALIDATE)
                        console.log('validateToken _ /auth/validatetoken[then]', valResp);
                    if (typeof valResp !== "undefined" && valResp.hasOwnProperty('data') && valResp.data.result === 'success') {
                        if (DEBUG_MODE_VALIDATE)
                            console.log('validateToken - valid token, resolving');
                        return true;
                    }
                }
                catch (x) {
                }
                return yield this.refreshToken();
            }
        });
    }
    refreshToken() {
        if (DEBUG_MODE_VALIDATE)
            console.log('refreshToken - start', 'access', localStorage.getItem("tka"), 'refresh', localStorage.getItem("tkr"));
        const ref_tok = localStorage.getItem("tkr");
        if ((ref_tok == null) || (typeof ref_tok === "undefined")) {
            if (DEBUG_MODE_VALIDATE)
                console.log('refreshToken - no refresh token, rejecting');
            return false;
        }
        // if the token is already being refreshed return a promise
        if (refreshTokenPromise) {
            return refreshTokenPromise;
        }
        if (!this.token) {
            return false;
        }
        refreshTokenPromise = this.token.refresh({
            body: {
                client_id: this.OAUTH_SERVER_CONF.CLIENT_ID,
                client_secret: this.OAUTH_SERVER_CONF.CLIENT_SECRET,
            },
        });
        refreshTokenPromise.then(updatedToken => {
            if (typeof updatedToken !== "undefined" && updatedToken.hasOwnProperty("accessToken")) {
                if (DEBUG_MODE_VALIDATE)
                    console.log('refreshToken _ refresh[then], store & resolve', updatedToken);
                // Store access and refresh tokens
                this.token = updatedToken;
                localStorage.setItem("tka", updatedToken.accessToken);
                localStorage.setItem("tkr", updatedToken.refreshToken);
                // Use access token for auth in API calls
                this.AuthAPIs.forEach((itApi) => {
                    itApi.setHeaderCommons('Authorization', 'Bearer ' + updatedToken.accessToken);
                });
                refreshTokenPromise = undefined;
            }
            else {
                if (DEBUG_MODE_VALIDATE)
                    console.log('refreshToken _ refresh[then - bad], clear & reject');
            }
        }).catch(error => {
            if (DEBUG_MODE_VALIDATE)
                console.log('refreshToken _ refresh[catch], clear & reject', error);
        });
        return refreshTokenPromise;
    }
    handleLogin(req) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a, _b, _c;
            //Store intended route to launch on redirect
            let intRoute = req.fullPath;
            if (req.query.hasOwnProperty('intendedroute')) {
                intRoute = req.query.intendedroute;
            }
            localStorage.setItem('intended_route', intRoute);
            if (req.query.action === 'user_app_link' && typeof req.query.u !== 'undefined') {
                var buffAppLinkUserGuid = Buffer.from(req.query.u.toString(), 'base64');
                var appLinkUserGuid = buffAppLinkUserGuid.toString();
                //Remove action and u params from intended route
                intRoute = intRoute.replace('action=user_app_link', '').replace('u=' + req.query.u.toString(), '').replace('?&', '').replace(/&+$/, "");
                localStorage.setItem('intended_route', intRoute);
                const tmpMagLinkParams = {
                    userGuid: appLinkUserGuid,
                    intendedRoute: intRoute,
                };
                if (process.env.VUE_APP_ENV === 'local') {
                    //Allow working with local URLs
                    tmpMagLinkParams.redirectURL = window.location.href.replace('action=user_app_link', '').replace('u=' + req.query.u.toString(), '').replace('?&', '').replace(/&+$/, "");
                }
                const linkResponse = yield ((_a = this.AuthAPI) === null || _a === void 0 ? void 0 : _a.post('/user/send-magic-link', tmpMagLinkParams));
                if (linkResponse && linkResponse.data && linkResponse.data.link) {
                    //Redirect to enter access code page
                    window.location.href = linkResponse.data.link;
                    return;
                }
            }
            // redirect to standard auth route
            window.location.href = (_c = (_b = this.oauthObj) === null || _b === void 0 ? void 0 : _b.code.getUri()) !== null && _c !== void 0 ? _c : "";
        });
    }
    handleLogout() {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            yield ((_a = this.AuthAPI) === null || _a === void 0 ? void 0 : _a.post('/auth/logout'));
            //Store intended route & redirect to auth route
            localStorage.removeItem("userBasics");
            localStorage.removeItem("tka");
            localStorage.removeItem("tkr");
            localStorage.removeItem('intended_route');
            this.AuthAPIs.forEach((itApi) => {
                itApi.setHeaderCommons('Authorization', null);
            });
            this.setJwtOverride(null);
        });
    }
    handleCallback(req) {
        const intendedRoute = localStorage.getItem('intended_route');
        localStorage.removeItem('intended_route');
        return new Promise((resolve) => {
            var _a;
            (_a = this.oauthObj) === null || _a === void 0 ? void 0 : _a.code.getToken(req.fullPath, {
                body: {
                    client_id: this.OAUTH_SERVER_CONF.CLIENT_ID,
                    client_secret: this.OAUTH_SERVER_CONF.CLIENT_SECRET,
                },
            }).then((newToken) => {
                var _a, _b, _c, _d;
                // Store access and refresh tokens
                localStorage.setItem("tka", newToken.accessToken);
                localStorage.setItem("tkr", newToken.refreshToken);
                // Use access token for auth in API calls
                this.AuthAPIs.forEach((itApi) => {
                    itApi.setHeaderCommons('Authorization', 'Bearer ' + newToken.accessToken);
                });
                this.token = (_d = (_a = this.oauthObj) === null || _a === void 0 ? void 0 : _a.createToken((_b = localStorage.getItem("tka")) !== null && _b !== void 0 ? _b : "", (_c = localStorage.getItem("tkr")) !== null && _c !== void 0 ? _c : "", 'bearer', {})) !== null && _d !== void 0 ? _d : undefined;
                window.location.href = intendedRoute;
                resolve(true);
            });
        });
    }
    getCurrentWebToken() {
        if (this.hasJwtOverride()) {
            return this.getJwtOverride();
        }
        return localStorage.getItem('tka');
    }
    hasCurrentWebToken() {
        if (this.hasJwtOverride()) {
            return true;
        }
        if (localStorage.getItem('tka')) {
            return true;
        }
        return false;
    }
    getCurrentRefreshToken() {
        if (this.hasJwtOverride()) {
            return null;
        }
        return localStorage.getItem('tkr');
    }
    hasCurrentRefreshToken() {
        if (this.hasJwtOverride()) {
            return false;
        }
        if (localStorage.getItem('tkr')) {
            return true;
        }
        return false;
    }
    setJwtOverride(jwt) {
        this.jwt_override = jwt;
    }
    hasJwtOverride() {
        return this.jwt_override !== null && this.jwt_override != '';
    }
    getJwtOverride() {
        return this.jwt_override;
    }
}
export default new APIHelper();
